import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportComponent } from './report/report.component';
import { SkeletonCommonModule } from '../../common/components/common.module';
import { ParagraphModule } from '../../paragraph/components/paragraph.module';
import { ArticleComponent } from './article/article.component';
import { DashboardComponent } from './dashboard/dashboard.component';

@NgModule({
  declarations: [ReportComponent, ArticleComponent, DashboardComponent],
  imports: [CommonModule, SkeletonCommonModule, ParagraphModule],
  exports: [ReportComponent]
})
export class ReportModule {}
